export default {
  en: {
    heading: 'Previous dialogues',
    allDialoguesAria: 'All dialogues',
    lessonTitle: 'Lesson',
    freeConversationTitle: 'Free conversation',
    yesterday: 'Yesterday',
  },
  ru: {
    heading: 'Предыдущие диалоги',
    allDialoguesAria: 'Все диалоги',
    lessonTitle: 'Урок',
    freeConversationTitle: 'Свободный разговор',
    yesterday: 'Вчера',
  },
  de: {
    heading: 'Frühere Dialoge',
    allDialoguesAria: 'Alle Dialoge',
    lessonTitle: 'Lektion',
    freeConversationTitle: 'Freies Gespräch',
    yesterday: 'Gestern',
  },
  pt: {
    heading: 'Diálogos anteriores',
    allDialoguesAria: 'Todos os diálogos',
    lessonTitle: 'Lição',
    freeConversationTitle: 'Conversa livre',
    yesterday: 'Ontem',
  },
  fr: {
    heading: 'Dialogues précédents',
    allDialoguesAria: 'Tous les dialogues',
    lessonTitle: 'Leçon',
    freeConversationTitle: 'Conversation libre',
    yesterday: 'Hier',
  },
  es: {
    heading: 'Diálogos anteriores',
    allDialoguesAria: 'Todos los diálogos',
    lessonTitle: 'Lección',
    freeConversationTitle: 'Conversación libre',
    yesterday: 'Ayer',
  },
};
